import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "../store/store";
import { LOGIN_CHOICE } from "../views/auth/routes";
import { FREELANCER_HOME_PAGE } from "../views/freelancer/routes";
import { COLABORADOR_HOME } from "../views/colaborador/routes";
import { isTokenValid } from "../utils/isTokenValid";

type Props = {
  children: React.ReactElement;
};

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const location = useLocation();

  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const userToken = useSelector((s: RootState) => (s as any).auth?.accessToken);
  const freelancerToken = useSelector((s: RootState) => s.freelancerAuth?.accessToken);
  // Campo `accessToken`, o mesmo que o slice grava (ver BUG-006).
  const employeeToken = useSelector((s: RootState) => (s as any).employeeAuth?.accessToken);

  if (!rehydrated) return null;

  const userValid = isTokenValid(userToken);
  const freelancerValid = isTokenValid(freelancerToken);
  const employeeValid = isTokenValid(employeeToken);

  if (!userValid) {
    // Sem sessao de staff: quem tem sessao de colaborador volta ao portal em vez
    // de ver a tela de escolha de login, que sugeriria que a sessao expirou.
    if (employeeValid) return <Navigate to={COLABORADOR_HOME()} replace />;
    if (freelancerValid) return <Navigate to={FREELANCER_HOME_PAGE()} replace />;
    return <Navigate to={LOGIN_CHOICE()} replace state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;
